import { api } from "api/api";
import { AxiosError } from "axios";
import VeiculoViagemRastreamentoItem from "model/gestao/frotas/VeiculoViagemRastreamentoItem";

class VeiculoViagemRastreamentoService {

    getRastreamento() {
        return new Promise<VeiculoViagemRastreamentoItem[]>((resolve, reject): void => {
            let url = `/veiculoViagem/rastreamento`
            api
                .get(url)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
}

export default VeiculoViagemRastreamentoService;